import { request } from 'utils/request';
import { ICompany, ICreateCompany, IShareCompanyData } from './slice/types';

const companyApi = {
  getCompanies: (hiikoEnvironmentId: number) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/company`,
    });
  },

  createOrUpdateCompany: (
    hiikoEnvironmentId: number,
    data: ICompany | ICreateCompany,
  ) => {
    return request({
      method: 'POST',
      url: `hiiko_environment/${hiikoEnvironmentId}/company`,
      data,
    });
  },
  getCompanyById: (hiikoEnvironmentId: number, companyId: number) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/company/${companyId}`,
    });
  },
  shareCompany: (
    hiikoEnvironmentId: number,
    companyId: number,
    data: IShareCompanyData,
  ) => {
    return request({
      method: 'POST',
      url: `hiiko_environment/${hiikoEnvironmentId}/company/${companyId}/share`,
      data,
    });
  },

  deleteCompanySharing: ({
    envId,
    companyId,
    guestEnvId,
  }: {
    envId: number;
    companyId: number;
    guestEnvId: number;
  }) => {
    return request({
      method: 'DELETE',
      url: `hiiko_environment/${envId}/company/${companyId}/remove`,
      params: { remove_from_hiiko_environment_id: guestEnvId },
    });
  },
};

export default companyApi;
